export function toNullableInt(str?: string) {
    const val = Number.parseInt(str?.trim() ?? "", 10);
    if (Number.isNaN(val)) {
        return undefined;
    }
    return val;
}

export function toNullableFloat(str?: string) {
    const val = Number.parseFloat(str?.trim() ?? "");
    if (Number.isNaN(val)) {
        return undefined;
    }
    return val;
}

export function toString(str?: string) {
    const val = str?.trim() ?? "";
    if (val.length === 0) {
        return "";
    }
    return val;
}

export function toNullableString(str?: string) {
    const val = str?.trim() ?? "";
    if (val.length === 0) {
        return undefined;
    }
    return val;
}